"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultWithdrawState = void 0;
exports.defaultWithdrawState = {
    showWithdrawModal: false,
    isWithdrawing: false,
    isWithdrawn: false,
    transactionId: "",
    receiveTransactionId: "",
    withdrawnTransactionId: "",
    status: "",
};
//# sourceMappingURL=WalletWithdrawInterface.js.map